import { Injectable } from '@angular/core';
import { UtilsService } from './utils.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class NotificacionesService {

  constructor(private utilsService: UtilsService) { }

  success(message: string, isAlert?: boolean, title?: string) {
    title = this.utilsService.validarString(title) ? title : 'Exito';
    isAlert = this.utilsService.validarObjeto(isAlert) ? isAlert : false;
    if (isAlert)
      this.swalAlert(message, 'success');
    else
      this.swalToastr(message, title, 'success');
  }

  warning(message: string, isAlert?: boolean, title?: string) {
    title = this.utilsService.validarString(title) ? title : 'Advertencia';
    isAlert = this.utilsService.validarObjeto(isAlert) ? isAlert : false;
    if (isAlert)
      this.swalAlert(message, 'warning');
    else
      this.swalToastr(message, title, 'warning');
  }

  error(message: string, isAlert?: boolean, title?: string) {
    title = this.utilsService.validarString(title) ? title : 'Error';
    isAlert = this.utilsService.validarObjeto(isAlert) ? isAlert : false;
    if (isAlert)
      this.swalAlert(message, 'error');
    else
      this.swalToastr(message, title, 'error');
  }

  info(message: string, isAlert?: boolean, title?: string) {
    title = this.utilsService.validarString(title) ? title : 'Informacion';
    isAlert = this.utilsService.validarObjeto(isAlert) ? isAlert : false;
    if (isAlert)
      this.swalAlert(message, 'info');
    else
      this.swalToastr(message, title, 'info');
  }

  swalToastr(message, title, type) {
    Swal.fire({
      title: title,
      text: message,
      icon: type,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      }
    });
  }

  swalAlert(message, type) {
    Swal.fire({
      title: message,
      icon: type,
      showConfirmButton: false,
      timer: 3000,
      toast: true,
      position: 'top-end',
      timerProgressBar: false,
      // onOpen: (toast) => {
      //   toast.addEventListener('mouseenter', Swal.stopTimer)
      //   toast.addEventListener('mouseleave', Swal.resumeTimer)
      // },
      width: 300
    });
  }

  question(title: string, content: string): any {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    });

    return swalWithBootstrapButtons.fire({
      title: title,
      text: content,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    });
  }
}
